<template>
  <div class="c-landing">
    <quote-carousel :items="quotes" class="c-landing__quotes"/>
      <div class="c-landing__introduction">
        <p>Je bent vandaag (nog) niet (helemaal) vertrouwd met de trends die de toekomst van jouw bedrijf kunnen bepalen? Je hebt de indruk dat je niet helemaal mee bent met de laatste trends? Zijn er buzz-woorden die je niet helemaal begrijpt? Of zie je gewoon door het bos de bomen niet meer wat innovatie betreft? Je vindt het eenvoudigweg aangenaam om begeleid te worden naar je toekomst?</p>
        <p>Geen nood, doorloop de UNIZO Future Forward scan en identificeer de prioriteiten voor de toekomst van jouw bedrijf! We helpen je graag op weg bij het ontdekken van sommige trends die jouw sector drastisch kunnen veranderen in de toekomst.</p>
      </div>
      <navigation-button to="infointroduction">Start met jouw Future Forward</navigation-button>
      <div class="c-footer">
        <p>UNIZO wil je graag ondersteunen om ook in de toekomst succesvol en relevant te zijn, daarom ontwikkelen we deze tool graag continu verder. Heb je suggesties, opmerkingen of vragen, dan lezen we ze graag via: <a href="mailto:futureforward@unizo.be">futureforward@unizo.be</a></p>
        <p>Om de inhoud van de FutureForward scan op te luisteren hebben wij wat ons betreft gepaste voorbeelden gezocht en vermeld. Mocht je je als bedrijf in onze scan terugvinden en niet akkoord gaan met deze vermelding dan horen of lezen wij dit graag via telefoon op 0800 20 750 of via e-mail op <a href="mailto:ondernemerslijn@unizo.be">ondernemerslijn@unizo.be</a>.</p>
        <p>Mocht je als gebruiker van de FutureForward scan bepaalde inhoud ongepast vinden, dan verwelkomen wij je opmerkingen graag via dezelfde weg.</p>
        <p>UNIZO kan niet aansprakelijk gesteld worden voor businessbeslissingen die je neemt op basis van informatie uit de future forward scan of op basis van de opvolgingscoachings.</p>
    </div>
  </div>
</template>

<script>
import QuoteCarousel from '../components/QuoteCarousel.vue'
import NavigationButton from '../components/NavigationButton.vue'
export default {
  components: {
    QuoteCarousel,
    NavigationButton
  },
  data () {
    return {
      quotes: [
        'Welke technologiëen en toekomstscenario’s veranderen jouw sector?',
        'Met welke technologieën ga jij aan de slag?',
        'Op welke trends speel jij in?',
        'Welke toekomstscenario’s verken jij?'
      ]
    }
  }
}
</script>

<style lang="scss">
@keyframes landing {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.c-landing {
  animation: 0.5s linear 0.2s 1 both landing;
  margin: auto 0;
}

.c-landing__quotes {
  margin-bottom: 2.4rem;
}

.c-landing__introduction {
  margin-bottom: 4rem;
}
</style>
